<template>
  <div :class="['text-container', container_class]">
      <p v-if="type === 'heading'" class="text-primary uppercase font-bold text-5xl" v-text="content"></p>
      <p v-else-if="type === 'paragraph'" class="text-grey-darkest text-4xl" v-text="content"></p>
      <p v-else-if="type === 'message'" class="text-primary text-4xl font-medium" v-text="content"></p>
      <p v-else-if="type === 'subtitle'" class="text-primary text-5xl font-medium" v-text="content"></p>
      <p v-else-if="type === 'bubble'" class="text-primary text-4xl font-medium" v-text="content"></p>
      <p v-else-if="type === 'dynamic'" :class="['text-dynamic', dynamic_class]" v-text="content"></p>
  </div>
</template>

<script>
import mixin from '@/mixins/controls.js';

export default {
  name: 'v-word',
  mixins: [
    mixin
  ],
  props: {
    type: {
      type: String,
      default: 'heading',
      validator(value) {
        return ['heading', 'paragraph', 'message', 'subtitle', 'bubble', 'dynamic'].includes(value);
      },
    },
    content: {
      type: String,
      default: '',
    },
    dynamic_class: {
      type: String,
      default: '',
    },
    container_class: {
      type: String,
      default: '',
    },
    pso_code: {
      type: String,
      default: '',
    }
  },
};
</script>

<style scoped>

</style>
